import { Settings as LayoutSettings } from '@ant-design/pro-layout';

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
} = {
  colorWeak: false,
  title: 'HomeCareQuote',
  pwa: false,
  logo: 'https://homecarequote.com/wp-content/uploads/2022/06/homecarequote-logo_r.svg',
  iconfontUrl: '',
  navTheme: 'dark',
  primaryColor: '#f55951',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  splitMenus: false,
  footerRender: false,
  headerRender: false,
};

export default Settings;
